import React from "react";
import Projects from "../components/Projects";
import HackathonWins from "../components/HackathonWins";

const ProjectsPage = () => (
  <>
    <Projects />
    <HackathonWins />
  </>
);

export default ProjectsPage;
